var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MenuGeneratorLink"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.item.to}},[_vm._v(" "+_vm._s(_vm.item.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }